import { assign, cloneDeep } from 'lodash'

import {
  NOTIFICATIONS_DELETE,
  NOTIFICATIONS_DELETE_CANCELED,
  NOTIFICATIONS_DELETE_ERROR,
  NOTIFICATIONS_DELETE_FULFILLED,
  NOTIFICATIONS_FETCH,
  NOTIFICATIONS_FETCH_CANCELED,
  NOTIFICATIONS_FETCH_ERROR,
  NOTIFICATIONS_FETCH_FULFILLED,
  NOTIFICATIONS_INITIAL_STATE,
  NOTIFICATIONS_VIEW,
  NOTIFICATIONS_VIEW_CANCELED,
  NOTIFICATIONS_VIEW_ERROR,
  NOTIFICATIONS_VIEW_FULFILLED,
} from './NotificationsActions'

export default (state = NOTIFICATIONS_INITIAL_STATE, action = {}) => {
  switch (action.type) {
    case NOTIFICATIONS_DELETE: {
      const newState = cloneDeep(state)
      if (newState.all.data[0].notifications) {
        newState.all.data[0].notifications = newState.all.data[0].notifications.map((notification) => ({
          ...notification,
          deleting: notification.deleting || action.payload.id === notification.id,
        }))
      }
      return newState
    }
    case NOTIFICATIONS_DELETE_CANCELED: {
      return state
    }
    case NOTIFICATIONS_DELETE_ERROR: {
      const newState = cloneDeep(state)
      if (newState.all.data[0].notifications) {
        newState.all.data[0].notifications = newState.all.data[0].notifications.map((notification) => ({
          ...notification,
          deleting: notification.deleting && action.payload.id !== notification.id,
        }))
      }
      return newState
    }
    case NOTIFICATIONS_DELETE_FULFILLED: {
      const newState = cloneDeep(state)
      if (newState.all.data[0].notifications) {
        newState.all.data[0].notifications = newState.all.data[0].notifications.filter(
          (notification) => notification.id !== action.payload.data[0].id,
        )
      }
      return newState
    }

    case NOTIFICATIONS_FETCH: {
      const type = action.payload.type === 'all' || !action.payload.type ? 'all' : action.payload.type
      const newState = cloneDeep(state)

      newState[type].loaded = false
      newState[type].loading = true
      return newState
    }
    case NOTIFICATIONS_FETCH_CANCELED: {
      return state
    }
    case NOTIFICATIONS_FETCH_ERROR: {
      const type = action.payload.type === 'all' || !action.payload.type ? 'all' : action.payload.type
      const newState = cloneDeep(state)

      newState[type].error = action.payload
      newState[type].loaded = true
      newState[type].loading = false
      return newState
    }
    case NOTIFICATIONS_FETCH_FULFILLED: {
      const type = action.payload.type === 'all' || !action.payload.type ? 'all' : action.payload.type
      const newState = cloneDeep(state)

      if (!action.payload.pagination || action.payload.pagination.current_page === 1) {
        newState[type] = action.payload
      } else {
        const notifications = [
          ...(newState[type].data[0]?.notifications || []),
          ...(action.payload.data[0]?.notifications || []),
        ]
        newState[type].data = [{ ...newState[type].data[0], ...action.payload.data[0], notifications }]
        newState[type].pagination = action.payload.pagination
        newState[type].error = action.payload.error
      }
      newState[type].loaded = true
      newState[type].loading = false
      return newState
    }

    case NOTIFICATIONS_VIEW: {
      return state
    }
    case NOTIFICATIONS_VIEW_CANCELED: {
      return state
    }
    case NOTIFICATIONS_VIEW_ERROR: {
      return state
    }
    case NOTIFICATIONS_VIEW_FULFILLED: {
      const newState = cloneDeep(state)
      newState.unseen = assign(cloneDeep(NOTIFICATIONS_INITIAL_STATE.unseen, { loaded: true }))
      if (newState.all.data[0].notifications) {
        newState.all.data[0].notifications = newState.all.data[0].notifications.map((notification) => ({
          ...notification,
          viewed_at: Date.now(),
        }))
      }
      return newState
    }

    default:
  }
  return state
}
